import type { StaffRole } from '@ucp/web/lib';

/**
 * Survey surface roles (PRO-3060, ADR-018 PRO-3060 amendment). Mirrors the server role →
 * capability map; the server stays authoritative (503 before 403, per-school capability
 * checks). `L6_PLATFORM_ADMIN` holds no survey capability and is never listed.
 */
export const SURVEY_ADMIN_ROLES: StaffRole[] = ['SURVEY_ADMIN'];
/** `survey_recipients_review` at the active school. */
export const SURVEY_RECIPIENT_ROLES: StaffRole[] = ['L1_SENDER', 'PRINCIPAL'];
/** `survey_results_read` / `survey_responses_read` / `survey_followup_work` at the active school. */
export const SURVEY_SCHOOL_FEEDBACK_ROLES: StaffRole[] = ['SURVEY_FEEDBACK_REVIEWER', 'PRINCIPAL'];
/** `survey_group_results_read` (caller-scoped). */
export const SURVEY_GROUP_RESULTS_ROLES: StaffRole[] = [
  'SURVEY_ADMIN',
  'OPS_DIRECTOR',
  'CEO',
  'COO',
];
/** `survey_group_comments_read` (group-wide, pseudonymous). */
export const SURVEY_GROUP_COMMENTS_ROLES: StaffRole[] = ['SURVEY_ADMIN'];
/** `survey_export_aggregate` (caller-scoped). */
export const SURVEY_AGGREGATE_EXPORT_ROLES: StaffRole[] = [
  'SURVEY_ADMIN',
  'PRINCIPAL',
  'OPS_DIRECTOR',
  'CEO',
  'COO',
];
/** `survey_export_identifiable` at the active school. */
export const SURVEY_IDENTIFIABLE_EXPORT_ROLES: StaffRole[] = ['PRINCIPAL'];
/** `complaint_record` at the active school: offers "Raise as complaint" in the queue (AC 73). */
export const COMPLAINT_RECORD_ROLES: StaffRole[] = ['COMPLAINT_HANDLER'];

/** The module route guard and nav item: any role that confers a survey capability. */
export const SURVEY_ROUTE_ROLES: StaffRole[] = [
  'SURVEY_ADMIN',
  'SURVEY_FEEDBACK_REVIEWER',
  'L1_SENDER',
  'PRINCIPAL',
  'OPS_DIRECTOR',
  'CEO',
  'COO',
];
